export enum AmountType {
  Main = 'Main',
  Interests = 'Interests',
  Fees = 'Fees',
  Total = 'Total',
}
